'use strict';

var modelo = function () {
  var totalVehicles = void 0,
      currentVehicles = void 0;

  var _getCompleteName = function _getCompleteName(name) {
    return utils.getDisplayModelName(name).completeName;
  };

  var _setTotalVehicles = function _setTotalVehicles(value) {
    return totalVehicles = value;
  };
  var _getTotalVehicles = function _getTotalVehicles() {
    return totalVehicles;
  };

  var _setCurrentVehicles = function _setCurrentVehicles(value) {
    return currentVehicles = value;
  };
  var _getCurrentVehicles = function _getCurrentVehicles() {
    return currentVehicles;
  };

  var _init = function _init(models, area) {
    if (models.ok) _getData(models);
    $('.js-sort-select').on('change', function () {
      _print(_getCurrentVehicles());
    });
    var modelName = models.dealersVehicles[0].vehicle.vdisplayModelo;
    _printTitle(modelName, area);
    _addMetaDescription(modelName, area);
    _printBreadCrum(modelName);
    _printH1(modelName, area);

    var footerHeight = $('#nissan_global_footer').length > 0 ? $('#nissan_global_footer').innerHeight() : 0;

    window.onscroll = function () {
      if (_getScrollTop() < _getDocumentHeight() - (window.innerHeight + footerHeight)) return;
      _addPage();
    };

    $(window).on('scroll', function () {
      _getScrollTop() < window.innerHeight * 1.5 ? $('.js-top').removeClass('active') : $('.js-top').addClass('active');
    });

    $('.js-top').on('click', function () {
      $('html, body').animate({ scrollTop: $('.js-home-section').offset().top }, 300);
    });
  };

  var _nissanModelName = function _nissanModelName(modelname) {
    return utils.getDisplayModelName(modelname).hasOwnProperty('new') ? utils.getDisplayModelName(modelname).new + ' Nissan ' + utils.getDisplayModelName(modelname).name : 'NISSAN ' + _getCompleteName(modelname);
  };

  var _printTitle = function _printTitle(modelname, area) {
    var areaDisplayName = utils.getDisplayAreaName(area);
    document.title = _nissanModelName(modelname).toUpperCase() + ' | Veh\xEDculos Nuevos en Stock Disponibles en ' + areaDisplayName;
  };

  var _addMetaDescription = function _addMetaDescription(modelname, area) {
    var nissanModelName = _nissanModelName(modelname).toUpperCase();
    var areaDisplayName = utils.getDisplayAreaName(area);
    var modelDisplayName = utils.getDisplayModelName(modelname).completeName;
    var metaContent = nissanModelName + ' | Encuentra una amplia gama de veh\xEDculos ' + nissanModelName + ' nuevos en stock disponibles ahora en ' + areaDisplayName + '. Tu nuevo ' + modelDisplayName + ' te est\xE1 esperando.';
    var metaTag = document.createElement('meta');
    metaTag.setAttribute('name', 'description');
    metaTag.setAttribute('content', metaContent);
    document.head.appendChild(metaTag);
  };

  var _printH1 = function _printH1(modelname, area) {
    var h1Elem = document.querySelector('.js-h1');
    var h1Text = h1Elem.textContent;
    var modelDisplayName = utils.getDisplayModelName(modelname).completeName.toUpperCase();
    var areaDisplayName = utils.getDisplayAreaName(area).toUpperCase();
    h1Text = h1Text + ' - ' + modelDisplayName + ' (' + areaDisplayName + ')';
    if (typeof modelDisplayName !== 'undefined' && typeof areaDisplayName !== 'undefined') h1Elem.textContent = h1Text;
    h1Elem.classList.remove('hidden');
  };

  var _printBreadCrum = function _printBreadCrum(modelname) {
    $('.js-page').text('' + _getCompleteName(modelname));
  };

  var _getData = function _getData(models) {
    $('.js-home-section-loading').fadeIn();
    var vehicles = models.dealersVehicles;
    // console.log(vehicles)
    _setTotalVehicles(vehicles);
    _print(vehicles);
    $('.js-filters-button').on('click', function () {
      $('.block-1-1').toggleClass('active');
    });
    modelFilters.buildFilterLists(vehicles);
  };

  // PAGINATION ////////////////////////////////

  var _getDocumentHeight = function _getDocumentHeight() {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  };

  var _getScrollTop = function _getScrollTop() {
    return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  };

  var pagination = {
    min: 0,
    interval: 6
  };

  var _resetVehiclesList = function _resetVehiclesList(vehicles) {
    var vehiclesSorted = _sortPrices(vehicles);
    _setCurrentVehicles(vehiclesSorted);
    pagination.min = 0;
    $('.js-list').empty();
  };

  var _hideMessages = function _hideMessages() {
    $('.js-no-results').addClass('hidden');
    $('.js-home-section-loading').hide();
  };

  var _showNoResults = function _showNoResults() {
    $('.js-no-results').removeClass('hidden');
  };

  var _print = function _print(vehicles) {
    _resetVehiclesList(vehicles);

    if (vehicles.length > 0) {
      _hideMessages();
      var pageVehicles = _makePageArray();
      _printPage(pageVehicles);
      $('.js-list').slideDown();
    } else {
      _showNoResults();
    }
  };

  var _incrementPage = function _incrementPage() {
    pagination.min += pagination.interval;
  };

  var _makePageArray = function _makePageArray() {
    var vehiclesList = _getCurrentVehicles();
    var pageVehicles = [];
    for (var i = pagination.min; i < pagination.min + pagination.interval && i < vehiclesList.length; i++) {
      pageVehicles.push(vehiclesList[i]);
    }
    return pageVehicles;
  };

  var _addPage = function _addPage() {
    _incrementPage();
    var pageVehicles = _makePageArray();
    _printPage(pageVehicles);
  };

  $('.js-page-test').on('click', function () {
    _addPage();
  });

  var _printPage = function _printPage(vehicles) {
    var _loop = function _loop(model) {
      var $elem = $(_template_grid(vehicles[model]));
      $('.js-list').append($elem);
      function _showElem() {
        $elem.find('.fade-enter').removeClass('inactive');
      }
      window.setTimeout(_showElem, 100);
    };

    for (var model in vehicles) {
      _loop(model);
    }
    // tagging Analytics 
    gtagApp.init({ page: 'modelo', area: gtag.area, model: gtag.modelo });
  };

  var _template_grid = function _template_grid(model) {
    var modelNameObj = utils.getDisplayModelName(model.vehicle.vdisplayModelo),
        modelNewNode = modelNameObj.hasOwnProperty('new') ? '<span class="grid_vn-pretitle">' + modelNameObj.new + '</span>' : '',
        modelName = modelNameObj.name,
        modelUrl = '' + model.vehicle.vdisplayModelo.toLowerCase().replace(/ /, '-');
    var images = vehicleImg.getColorsAndImgs(model.vehicle, '3l4f', '507x321');
    var composedImage = '';
    for (var layer in images.urls) {
      composedImage += '<img class="img" alt="' + modelName + '" src="https://configurador.nissan.es/' + images.urls[layer] + '" />';
    }

    /* *****************************************************************+ */

    var pce = new PCE({
      model: model.vehicle.vmodelo,
      isCommercial: 'false',
      isElectric: model.vehicle.vcombustible.startsWith('El'),
      modelcb: model.vehicle.vmodelo,
      codCom: model.vehicle.vcodcom17,
      homologacion: model.vehicle.vfaseHomologacion,
      performance: {
        acceleration: '' + model.vehicle.naceleracion,
        maxspeed: '' + model.vehicle.nvelocidad,
        power: model.vehicle.vpotencia,
        body: model.vehicle.vcarroceria,
        torque: '' + model.vehicle.npar,
        cc: '' + model.vehicle.ncilindrada,
        fuel: model.vehicle.vcombustible,
        range: model.vehicle.vautonomia,
        mma: model.vehicle.vmma,
        payload: model.vehicle.vcargautil,
        cargoVol: model.vehicle.vvolumencarga,
        wheelbase: model.vehicle.vdistanciaejes,
        bodyMaxLength: '' + model.vehicle.ndistmaxcarro,
        turnRadius: model.vehicle.vradiogiro,
        doors: '' + model.vehicle.npuertas,
        seats: '' + model.vehicle.nplazas
      },
      consumptEmissions: {
        reglamentacion: model.vehicle.vreglamentacion,
        NEDCBT_CO2U: model.vehicle.nedcbt_co2u,
        NEDCBT_CO2EU: model.vehicle.nedcbt_co2eu,
        WLTP_FM: model.vehicle.wltp_fm,
        NEDC_CE: model.vehicle.nedc_ce,
        NEDC_CC: model.vehicle.nedc_cc,
        WLTP_ACU: model.vehicle.wltp_acu,
        NEDCBT_CO2CC: model.vehicle.nedcbt_co2cc,
        NEDC_ACC: model.vehicle.nedc_acc,
        NEDCBT_CU: model.vehicle.nedcbt_cu,
        NEDC_CU: model.vehicle.nedc_cu,
        WLTP_FB: model.vehicle.wltp_fb,
        WLTP_FA: model.vehicle.wltp_fa,
        vcodcom13: model.vehicle.vcodcom13,
        WLTP_CE: model.vehicle.wltp_ce,
        NEDC_CEU: model.vehicle.nedc_ceu,
        NEDCBT_ACC: model.vehicle.nedcbt_acc,
        NEDCBT_CC: model.vehicle.nedcbt_cc,
        NEDCBT_CE: model.vehicle.nedcbt_ce,
        homologacion: model.vehicle.vfaseHomologacion,
        WLTP_CO2A: model.vehicle.wltp_co2a,
        WLTP_CO2B: model.vehicle.wltp_co2b,
        WLTP_CO2M: model.vehicle.wltp_co2m,
        NEDC_CO2: model.vehicle.nedc_co2,
        NEDCBT_CEU: model.vehicle.nedcbt_ceu,
        WLTP_CO2EA: model.vehicle.wltp_co2ea,
        WLTP_ACC: model.vehicle.wltp_acc,
        WLTP_CC: model.vehicle.wltp_cc,
        WLTP_COCC: model.vehicle.wltp_cocc,
        WLTP_FEA: model.vehicle.wltp_fea
      }
    });

    /* ***************************************************************** */
    // console.log('model', model)

    var legalpriceObj = legal.getPriceLegal(model);
    var legalConditions = legalpriceObj.price + ' ' + legalpriceObj.offer + ' ' + legalpriceObj.registration + ' ' + legalpriceObj.moreInfo + ' ' + legalpriceObj.images + ' ' + pce.legalSimple;

    var elem = '\n    <div class="row">\n      <div class="col">\n        <article class="vn_offer_101 fade-enter inactive">\n          <div class="row row-flex align-stretch">\n            <div class="col_8">\n              <div class="row row-flex align-start">\n                <div class="vn_offer_101-fg">\n                  <figure class="vehicleImage l34" style="background-color: ' + model.vehicle.vhexadecimal + '">\n                    ' + composedImage + '\n                  </figure>\n                </div>\n                <div class="vn_offer_101-model">\n                  ' + modelNewNode + '\n                  <h3 class="model">' + modelName + ' ' + model.vehicle.vgrado + '</h3>\n                  <p class="version">\n                    <span class="title">\n                      ' + model.vehicle.vmotor + ' \n                      ' + model.vehicle.vtraccion + '\n                      ' + model.vehicle.vtransmision + '<br>\n                      <strong>\n                        ' + model.vehicle.vcolor + '\n                      </strong> (' + model.vehicle.vtipoColor + ')\n                    </span>\n                  </p>\n                  <div class="vn_offer_101-description">\n                    <p class="vn_offer_101-equipped js-equiped">EQUIPAMIENTO DESTACADO</p>\n                    <div class="js-characteristics">\n                      ' + model.vehicle.vequipamiento + '\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class="col_4 last-col">\n              <div class="price-block">\n                <p class="price">\n                  <span class="typeprice">POR</span>\n                  <span class="full-price">\n                  ' + utils.formatPrice(model.prices.precioOferta) + '\u20AC*</span>\n                </p>\n              </div>\n              <div class="vn_offer_101-cta">\n                <a class="h-link h-btn red arrow gtag-request dtm-cta"\n                  href="' + modelUrl + '/' + model.vcodCom + '/peticion"\n                  target="_parent" tabindex="0" data-tracking-id="toRequestOffer"\n                  data-tracking-label="action-panel" data-codcom="' + model.vehicle.vcodcom17 + '" data-version="' + model.vehicle.vgrado + '" data-pvp="' + model.prices.precioMostrar + '" data-offer="' + model.prices.precioOferta + '">HAZ TU PEDIDO</a>\n\n                <a class="h-link h-btn grey arrow gtag-details dtm-cta"\n                  href="' + modelUrl + '/' + model.vcodCom + '"\n                  target="_parent" tabindex="0" data-tracking-id="toRequestOffer"\n                  data-tracking-label="action-panel"\n                  data-codcom="' + model.vehicle.vcodcom17 + '" data-version="' + model.vehicle.vgrado + '" data-pvp="' + model.prices.precioMostrar + '" data-offer="' + model.prices.precioOferta + '">VER M\xC1S DETALLES</a>\n                <a href="#" class="conditions js-financial-conditions active">*Condiciones legales</a>\n              </div>\n            </div>\n          </div>\n          <div class="vn_offer-conditions js-vn_offer-conditions hidden">\n            <p class="vn_offer-cond-txt">*' + legalConditions + '</p>\n          </div>\n        </article>\n      </div>\n    </div>\n    ';
    var $elem = $(elem);
    $elem.find('.js-characteristics ul').addClass('vn_offer_101-characteristics');
    var $legalBtn = $elem.find('.js-financial-conditions');
    var $legalBlock = $elem.find('.js-vn_offer-conditions');
    $legalBtn.on('click', function (event) {
      event.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $legalBlock.removeClass('hidden');
        dtmTag.track.accordionExpansion('more legal information', $(this).text());
      } else {
        $(this).addClass('active');
        $legalBlock.addClass('hidden');
      }
    });

    return $elem;
  };

  var _sortPrices = function _sortPrices(arr) {
    var asc = $('.js-sort-select').val() === 'up';
    return arr.sort(function (a, b) {
      if (asc) {
        return a.prices.precioOferta > b.prices.precioOferta ? 1 : a.prices.precioOferta < b.prices.precioOferta ? -1 : 0;
      } else {
        return b.prices.precioOferta > a.prices.precioOferta ? 1 : b.prices.precioOferta < a.prices.precioOferta ? -1 : 0;
      }
    });
  };

  return {
    init: _init,
    print: _print
  };
}();